<template>
  <div class="dushu-index-wrapper">
    <div class="tips">
      <div class="tips-animation">
        <div class="tips-text">数据后台每小时刷新，会造成部分数据最多延时显示1小时。如需实时获取订单信息，请打开订单信息实时推送功能。</div>
        <div class="tips-text">数据后台每小时刷新，会造成部分数据最多延时显示1小时。如需实时获取订单信息，请打开订单信息实时推送功能。</div>
      </div>
    </div>
    <div :class="[`${dateType}-wrapper`]" v-if="menuItems[0].active">
      <div style="display: flex; width: 100%;">
        <div class="title-select" style="width: 100%;" @click="showFilterModal">{{filterTitle}}</div>
        <!-- <div class="btn-export" @click="onExportData">导出数据</div> -->
      </div>

      <ul class="data-list">
        <li class="data-item" v-for="item in boardData" :key="item.title">
          <span class="title">{{item.title}}</span>
          <span :class="['data', item.class, boardDataMap[item.key] > 100000 ? 'large' : '']">{{formatNum(boardDataMap[item.key])}}</span>
        </li>
      </ul>

      <ul class="date-list center mt10">
        <li
          v-for="type in chartTypes"
          :key="type.key"
          :class="['date-item', type.className, chartType === type.key ? 'active' : '']"
          @click="onChangeChartType(type.key)"
        >
          {{type.title}}
        </li>
      </ul>

      <ve-line
        :tooltip="chartSettings"
        :data="statisticsDetailChartMap[chartType]"
        :extend="extend"
        :colors="['#e51c23', '#ffe5c8', '#e2efd3', '#24A2FF', '#4900BA', '#FFE000']"
        :legend="{show: (dateType === 'hour') || (dateType !== 'hour' && onlineType === 'all')}"
      />

      <ul class="date-list">
        <div class="block-select">
          <div class="date-select select-wrapper" v-if="dateType === 'hour'">
            <select @change="onChangeDay('singleDate', $event)">
              <option v-for="day in statisticDays" :value="day" :key="day" :selected="day === singleDate">{{day}}</option>
            </select>
            <span class="select-label">{{singleDate}}</span>
          </div>

          <template v-else>
            <div class="date-select select-wrapper">
              <select @change="onChangeDay('startDate', $event)">
                <option v-for="day in statisticDays" :value="day" :key="day" :selected="day === startDate">{{day}}</option>
              </select>
              <span class="select-label">{{startDate}}</span>
            </div>
            <div class="date-select select-wrapper">
              <select @change="onChangeDay('endDate', $event)">
                <option v-for="day in statisticDays" :value="day" :key="day" :selected="day === endDate">{{day}}</option>
              </select>
              <span class="select-label">{{endDate}}</span>
            </div>
          </template>

          <div class="date-select select-wrapper">
            <select @change="onChangeDay('onlineType', $event)">
              <option v-for="item in Object.keys(onlineTypeMap)" :value="item" :key="item" :selected="item === onlineType">{{onlineTypeMap[item]}}</option>
            </select>
            <span class="select-label">{{onlineTypeMap[onlineType]}}</span>
          </div>
        </div>

        <li v-for="item in dateTypes" :key="item.title" :class="['date-item', dateType === item.key ? 'active' : '']" @click="onChangeDateType(item.key)">{{item.title}}</li>
      </ul>

      <Table :data="tableStatistics" />
    </div>

    <template v-if="menuItems[1] && menuItems[1].active">
      <div class="filter-wrap">
        <div class="date-select select-wrapper">
          <select @change="onChangeTarget('targetSelectType', $event)">
            <option
              v-for="item in targetTypes"
              :key="item.value"
              :value="item.value"
              :selected="item.value === targetSelectType">
              {{item.name}}
            </option>
          </select>
          <span class="select-label">{{targetTypes.find(item =>{return item.value === targetSelectType}).name}}</span>
        </div>
        <div class="date-select select-wrapper" style="width: 65px;">
          <select @change="onChangeTarget('targetSelectYear', $event)">
            <option
              v-for="year in targetYears"
              :key="year"
              :value="year"
              :selected="+year === +targetSelectYear">
              {{year}}
            </option>
          </select>
          <span class="select-label">{{targetYears.find(item =>{return +item === +targetSelectYear})}}</span>
        </div>
        <div class="date-select select-wrapper" style="width: 70px;">
          <select @change="onChangeTarget('targetValue', $event)">
            <option
              v-for="day in targetValues"
              :key="day"
              :value="day"
              :selected="day === +targetValue"
            >
              {{targetSelectType==='week' ? `第${day}周` : `${day}月`}}
            </option>
          </select>
          <span class="select-label">{{targetSelectType==='week' ? `第${targetValue}周` : `${targetValue}月`}}</span>
        </div>
      </div>
      <div class="date-list center mt10">
        <div class="select-wrapper">
          <span class="text-label">{{`本${targetSelectType==='week'?'周':'月'}已过`}}
            <strong>{{`${completeness}%`}}</strong>
          </span>
        </div>
      </div>
      <div class="target-table-wrap" v-if="showTargetTable">
        <div class="target-table-item bg-gray">
          <div class="header-wrap"></div>
          <div class="header-wrap">KA合作方<br/>-新客</div>
          <div class="header-wrap">普通合作方<br/>-新客</div>
          <div class="header-wrap">KA合作方<br/>-老客</div>
          <div class="header-wrap">普通合作方<br/>-老客</div>
        </div>
        <div :class="['target-table-item', item.key.indexOf('Percent') !== -1 ? 'red-line' : '']" v-for="item in targetValueTypes" :key="item.key">
          <div class="content-wrap">{{item.title}}</div>
          <div class="content-wrap">{{getTargetValue(1, 0, item.key)}}</div>
          <div class="content-wrap">{{getTargetValue(0, 0, item.key)}}</div>
          <div class="content-wrap">{{getTargetValue(1, 1, item.key)}}</div>
          <div class="content-wrap">{{getTargetValue(0, 1, item.key)}}</div>
        </div>
      </div>
    </template>

    <template v-if="menuItems[2] && menuItems[2].active">
      <RankPanel :providerTypes="providerTypes" />
    </template>

    <i class="data-loading" v-if="isLoading">数据加载中...</i>
    <Menu class="fixed-menu" :items="menuItems" @on-change-menu="onChangeMenu" />

    <FilterModal
      :visible="isFilterModalVisible"
      :metaParams="{
        businessTypes,
        onlineTypes,
        providerTypes,
        providers,
      }"
      :filterParams="filterParams"
      @on-change-filter="onChangeFilterParams"
      @on-submit="onFetchProvidersStatistics"
    />
  </div>
</template>

<script>
import moment from 'moment'

import VeLine from 'v-charts/lib/line.common'
import 'echarts/lib/component/legendScroll'

import Menu from '@/components/dushu/Menu.vue'
import Table from '@/components/dushu/Table.vue'
import FilterModal from '@/components/dushu/FilterModal.vue'

import Dushu from '@/engine/Dushu'

import chartsPng from '@/assets/dushu/charts.png'
import chartsActivePng from '@/assets/dushu/charts_active.png'
import detailPng from '@/assets/dushu/detail.png'
import detailActivePng from '@/assets/dushu/detail_active.png'
import groupPng from '@/assets/dushu/group.png'
import groupActivePng from '@/assets/dushu/group_active.png'

import Utils from './Utils'
import RankPanel from './RankPanel.vue';
import { utils } from '@/util/index'

const state = {
  channelMap: {},
  channels: {},
  users: {},
  onlineTypeMap: {
    all: ['新客户', '老客户'],
    new: ['新客户'],
    old: ['老客户'],
  },
  statisticsDetailChartMap: {
    profit:  ['日期', '今日利润'],
    income: ['日期', '今日收入'],
    follow: ['日期', '今日新增关注'],
    arpu: ['日期', '今日arpu'],
    arppu: ['日期', '今日arppu'],
  },
  providerMap: {},
}

const formatOrders = (vm) => {
  vm.isLoading = true
  Dushu.partnerGetOrders(vm.selectedDate.value).then(({ data }) => {
    vm.tableOrders.body = data.map(({ date, nickname, amount, channel }) => {
      const displayChannel = state.channelMap[channel] || channel || '其他'
      if (!state.channels[displayChannel]) {
        state.channels[displayChannel] = 0
      }
      state.channels[displayChannel] += 1

      return [
        date.substring(0, 10),
        date.substring(11, 19),
        nickname,
        parseInt(amount / 100),
        displayChannel,
      ]
    })

    vm.chartPieData.rows = Object.keys(state.channels).filter((item) => {
      return !!state.channels[item]
    }).map((item) => {
      return {
        name: `${item}: ${(state.channels[item] * 100 / data.length).toFixed(2)}%`,
        value: state.channels[item],
      }
    }).sort((itemA, itemB) => {
      if (itemA.value > itemB.value) {
        return -1
      }
      if (itemA.value < itemB.value) {
        return 1
      }
      return 0
    })

    vm.isLoading = false
  })
}

const fetchUsers = (vm) => {
  vm.isLoading = true
  const pageSize = 100
  const isVip = vm.userParams.isVip === 'all' ? undefined : vm.userParams.isVip
  const gender = vm.userParams.gender === 'all' ? undefined : vm.userParams.gender

  Dushu.partnerListUsers(gender, isVip, pageSize, vm.paginationData['current_page']).then(({ data, lastDayIncr, total }) => {
    vm.users.lastDayIncr = lastDayIncr
    vm.users.total = total
    state.users = {}
    vm.users.body = data.map(({ nickname, gender, country, city, province, isRobotFriend, subscribed, isVip }) => {
      return [
        nickname,
        vm.selectMap.gender[gender],
        province || city || country,
        isRobotFriend ? {html: '<span class="red">是</span>'} : '否',
        subscribed ? {html: '<span class="red">是</span>'} : '否',
        isVip ? {html: '<span class="red">是</span>'} : '否'
        // groupsCount,
      ]
    // }).forEach((item, index) =>{
    //   const pageIndex = parseInt(index / pageSize, 10) + 1
    //   if (!state.users[pageIndex]) {
    //     state.users[pageIndex] = []
    //   }
    //   state.users[pageIndex].push(item)
    })
    vm.paginationData.total = total
    // vm.paginationData['current_page'] = 1
    vm.paginationData['last_page'] = parseInt((total - 1) / pageSize, 10) + 1
    // vm.users.body = state.users[1]
    vm.isLoading = false
  })
}

const partnerGetAvailableOrderDate = (vm) => { // eslint-disable-line
  vm.isLoading = true
  Dushu.partnerGetAvailableOrderDate().then(({ data }) => {
    vm.dates = [{
      label: '全部',
      value: '',
    }, ...data.map((item) => {
      return {
        label: item ? item.substring(0, 10) : '',
        value: item,
      }
    })]
    if (data && data.length) {
      vm.selectedDate = vm.dates[0]
      formatOrders(vm)
    }
  })
}

const fetchProviders = (vm, isNeedDiff) => {
  return Dushu.getProviderStatisticsVisibleProviders(vm.filterParams).then(({ providers: originProviders }) => {
    const providers = originProviders.map((provider) => {
      state.providerMap[provider.providerId] = provider.readableName
      return {
        ...provider,
        providerId: parseInt(provider.providerId, 10),
      }
    })
    vm.providers = [ ...providers ]
    const newProviders = providers.map(({ providerId }) => {
      return providerId
    })
    if (!isNeedDiff) {
      vm.filterParams.providers = newProviders
    } else {
      vm.filterParams.providers = newProviders.filter((providerId) => {
        return vm.filterParams.providers.includes(providerId)
      })
    }
  })
}

const fetchProvidersStatistics = (vm) => {
  Dushu.getProvidersStatisticsSummary(vm.filterParams).then((data) => {
    Object.keys(data).forEach((key) => {
      vm.boardDataMap[key] = parseInt(data[key], 10)
    })
  })
}

const formatDateTitle = (vm, item) => {
  let dateTitle = ''
  switch (vm.dateType) {
    case 'hour':
      dateTitle = `${parseInt(item.dateHour, 10)}:00-${parseInt(item.dateHour, 10) + 1}:00`
      break;
    case 'day':
      dateTitle = `${item.dateYear}${item.dateMonth}${item.dateDay}`
      break;
    case 'week':
      dateTitle = `${item.dateYear}第${item.dateWeek}周`
      break;
    case 'month':
      dateTitle = `${item.dateYear}${item.dateMonth}`
      break;
  }
  return dateTitle
}

const formatOneDay = (data) => {
  const dataObject = {}
  const newData = []
  data.forEach((item) => {
    dataObject[parseInt(item.dateHour, 10)] = item
  })
  new Array(24).fill(1).forEach((i, index) => {
    const newIndex = 23 - index
    newData.push(dataObject[newIndex] || {
      subscribeCount: 0,
      orderCount: 0,
      paidCount: 0,
      profitAmount: 0,
      paidAmount: 0,
      dateYear: "",
      dateMonth: "",
      dateWeek: "",
      dateDay: "",
      dateHour: newIndex
    })
  })
  return newData
}

const format7DaysData = (items = []) => {
  const dataObject = { length: 24 }
  const newData = []
  new Array(24).fill(1).forEach((i, index) => {
    const newIndex = 23 - index
    newData.push({
      subscribeCount: 0,
      orderCount: 0,
      paidCount: 0,
      profitAmount: 0,
      paidAmount: 0,
      dateYear: "",
      dateMonth: "",
      dateWeek: "",
      dateDay: "",
      dateHour: newIndex
    })
  })
  newData.forEach((item) => {
    dataObject[parseInt(item.dateHour, 10)] = item
  })
  items.forEach(item => {
    const dateHour = parseInt(item.dateHour, 10);
    const info = dataObject[dateHour];
    info.subscribeCount = parseInt(info.subscribeCount + item.subscribeCount, 10);
    info.orderCount = parseInt(info.orderCount + item.orderCount, 10);
    info.paidCount = parseInt(info.paidCount + item.paidCount, 10);
    info.profitAmount = parseInt(info.profitAmount + item.profitAmount, 10);
    info.paidAmount = parseInt(info.paidAmount + item.paidAmount, 10);

    dataObject[dateHour] = info;
  })

  return Array.from(dataObject);
}

const fetchProvidersStatisticsDetail = (vm) => {
  vm.isLoading = true
  vm.tableStatistics.head[0] = vm.dateType === 'hour' ? '时间段' : '日期'

  const params = {
    ...vm.filterParams,
    dataInterval: vm.dateType,
    onlineTypes: state.onlineTypeMap[vm.onlineType],
  };
  params.startDate = moment(vm.dateType === 'hour' ? vm.singleDate : vm.startDate).format('YYYY-MM-DDT00:00:00ZZ')
  params.endDate = moment(vm.dateType === 'hour' ? vm.singleDate : vm.endDate).format('YYYY-MM-DDT00:00:00ZZ')


  Dushu.getProvidersStatisticsDetail(params).then(({ items: data }) => {
    const statistics = []

    data.sort((firstEl, secondEl) => {
      return parseInt(`${secondEl.dateYear}${secondEl.dateMonth}${params.dataInterval === 'week' ? secondEl.dateWeek : secondEl.dateDay}${secondEl.dateHour}`, 10) - parseInt(`${firstEl.dateYear}${firstEl.dateMonth}${params.dataInterval === 'week' ? firstEl.dateWeek : firstEl.dateDay}${firstEl.dateHour}`, 10)
    })
    data.forEach((item) => {
      const className = []
      if (vm.dateType === 'day') {
        const dateDay = `${item.dateYear}${item.dateMonth}${item.dateDay}`
        if (moment(dateDay).date() === 1) {
          className.push('month')
        }
        if (moment(dateDay).day() === 1) {
          className.push('week')
        }
      }

      statistics.push({
        className,
        data: [
          formatDateTitle(vm, item),
          item.subscribeCount,
          item.orderCount,
          item.paidCount,
          parseInt(item.paidAmount, 10),
          parseInt(item.profitAmount, 10)
        ]
      })
    })
    vm.tableStatistics.body = statistics

    if (vm.dateType === 'hour') {
      fetch7DaysProvidersStatisticsDetail(vm)
      fetchRecentProvidersStatisticsDetail(vm)
      data = formatOneDay(data)
    } else if (vm.onlineType === 'all') {
      fetchAllProvidersStatisticsDetail(vm)
    }

    const rows = data.reverse().map((item) => {
      const itemData = {
        '日期': formatDateTitle(vm, item),
        '今日利润': parseInt(item.profitAmount, 10),
        '今日收入': parseInt(item.paidAmount, 10),
        '今日新增关注': item.subscribeCount,
        '今日arpu': (parseInt(item.paidAmount, 10) / (item.subscribeCount || 1)).toFixed(1),
        '今日arppu': (parseInt(item.paidAmount, 10) / (item.paidCount || 1)).toFixed(1),
        '昨日': '',
        '7天前': '',
        '老客户': '',
        '新客户': '',
      }
      Object.keys(itemData).forEach((key) => {
        if (key.includes('今日')) {
          itemData[key.replace(/今日/g, '全部')] = itemData[key]
        }
      })
      return itemData
    })

    fetchProvidersIncomeTargets(vm);

    Object.keys(vm.statisticsDetailChartMap).forEach((chartType) => {
      vm.statisticsDetailChartMap[chartType].columns = JSON.parse(JSON.stringify(state.statisticsDetailChartMap[chartType]))
      const columns = vm.statisticsDetailChartMap[chartType].columns

      const isHourDateType = vm.statisticsDetailChartMap[chartType].columns.includes('昨日')
      if (!isHourDateType && vm.dateType === 'hour') {
        vm.statisticsDetailChartMap[chartType].columns.push('昨日')
        vm.statisticsDetailChartMap[chartType].columns.push('7天前')
        vm.statisticsDetailChartMap[chartType].columns.push('7天总计')
      }

      const isAllOnlineType = vm.statisticsDetailChartMap[chartType].columns.includes('老客户')
      if (vm.dateType !== 'hour' && vm.onlineType === 'all') {
        vm.statisticsDetailChartMap[chartType].columns = columns.join(',').replace(/今日/g, '全部').split(',')
        if (!isAllOnlineType) {
          vm.statisticsDetailChartMap[chartType].columns.push('老客户')
          vm.statisticsDetailChartMap[chartType].columns.push('新客户')
        }
      }
      if (vm.dateType !== 'hour' && vm.onlineType !== 'all') {
        vm.statisticsDetailChartMap[chartType].columns = columns.join(',').replace(/全部/g, '今日').split(',')
      }

      if (vm.filterParams.providers.length === vm.providers.length && ['week', 'month'].includes(vm.dateType)) {
        if (!vm.statisticsDetailChartMap['income'].columns.includes('全部目标')) {
          vm.statisticsDetailChartMap['income'].columns.push('全部目标')
          vm.statisticsDetailChartMap['income'].columns.push('老客目标')
          vm.statisticsDetailChartMap['income'].columns.push('新客目标')
        }
      }

      vm.statisticsDetailChartMap[chartType].rows = rows
    })

    vm.isLoading = false
  }, () => {
    vm.isLoading = false
    vm.$toast('数据过载，或时间范围有误')
  })
}

const fetch7DaysProvidersStatisticsDetail = (vm) => {
  Dushu.getProvidersStatisticsDetail({
    ...vm.filterParams,
    dataInterval: vm.dateType,
    onlineTypes: state.onlineTypeMap[vm.onlineType],
    startDate: moment(vm.singleDate).subtract(6, 'd').format('YYYY-MM-DDT00:00:00ZZ'),
    endDate: moment(vm.singleDate).subtract(0, 'd').format('YYYY-MM-DDT00:00:00ZZ'),
  }).then(({ items }) => {
    const data = format7DaysData(items);
    formatRecentProvidersStatisticsDetail(vm, data, '7天总计')
  })
}

const fetchRecentProvidersStatisticsDetail = (vm) => {
  Dushu.getProvidersStatisticsDetail({
    ...vm.filterParams,
    dataInterval: vm.dateType,
    onlineTypes: state.onlineTypeMap[vm.onlineType],
    startDate: moment(vm.singleDate).subtract(1, 'd').format('YYYY-MM-DDT00:00:00ZZ'),
    endDate: moment(vm.singleDate).subtract(1, 'd').format('YYYY-MM-DDT00:00:00ZZ'),
  }).then(({ items: data }) => {
    formatRecentProvidersStatisticsDetail(vm, data, '昨日')
  })
  Dushu.getProvidersStatisticsDetail({
    ...vm.filterParams,
    dataInterval: vm.dateType,
    onlineTypes: state.onlineTypeMap[vm.onlineType],
    startDate: moment(vm.singleDate).subtract(7, 'd').format('YYYY-MM-DDT00:00:00ZZ'),
    endDate: moment(vm.singleDate).subtract(7, 'd').format('YYYY-MM-DDT00:00:00ZZ'),
  }).then(({ items: data }) => {
    formatRecentProvidersStatisticsDetail(vm, data, '7天前')
  })
}

const fetchAllProvidersStatisticsDetail = (vm) => {
  Dushu.getProvidersStatisticsDetail({
    ...vm.filterParams,
    dataInterval: vm.dateType,
    onlineTypes: state.onlineTypeMap.old,
    startDate: moment(vm.startDate).format('YYYY-MM-DDT00:00:00ZZ'),
    endDate: moment(vm.endDate).format('YYYY-MM-DDT00:00:00ZZ'),
  }).then(({ items: data }) => {
    formatRecentProvidersStatisticsDetail(vm, data, '老客户')
  })
  Dushu.getProvidersStatisticsDetail({
    ...vm.filterParams,
    dataInterval: vm.dateType,
    onlineTypes: state.onlineTypeMap.new,
    startDate: moment(vm.startDate).format('YYYY-MM-DDT00:00:00ZZ'),
    endDate: moment(vm.endDate).format('YYYY-MM-DDT00:00:00ZZ'),
  }).then(({ items: data }) => {
    formatRecentProvidersStatisticsDetail(vm, data, '新客户')
  })
}

const toPercent = (num, total) => {
    if(!total) return 0;
    return (Math.round(num / total * 10000) / 100.00 + "%");
}

const fetchProvidersIncomeTargets = (vm) => {
  const { providers, providerTypes } = vm.filterParams;

  if (providers.length !== vm.providers.length) return; // 合作方非全选
  if (!['week', 'month'].includes(vm.dateType)) return; // 非周、月

  Dushu.getProvidersIncomeTargets({ providerTypes: providerTypes }).then(({ items: data }) => {
    let targets = vm.dateType === 'week' ? data : data.filter(target => { return target.dateWeek === '0' });
    const newDatas = [];
    if (providerTypes.length !== 1) { // 非单选需累加
      targets.forEach(info => {
        let ndIndex = -1;
        if (vm.dateType === 'week') {
          ndIndex = newDatas.findIndex(nd => {
            return nd.dateYear === info.dateYear && nd.dateWeek === info.dateWeek
          })
        } else {
          ndIndex = newDatas.findIndex(nd => {
            return nd.dateYear === info.dateYear && nd.dateMonth === info.dateMonth
          })
        }

        if (ndIndex >= 0) {
          newDatas[ndIndex].totalTarget = parseInt(newDatas[ndIndex].totalTarget, 10) + parseInt(info.totalTarget, 10);
          newDatas[ndIndex].oldTarget = parseInt(newDatas[ndIndex].oldTarget, 10) + parseInt(info.oldTarget, 10);
          newDatas[ndIndex].newTarget = parseInt(newDatas[ndIndex].newTarget, 10) + parseInt(info.newTarget, 10);
        } else {
          newDatas.push(info);
        }
      });

      targets = newDatas;
    }

    targets.forEach(item => {
      const itemKey = vm.dateType === 'week' ? `${item.dateYear}第${item.dateWeek}周` : `${item.dateYear}${item.dateMonth}`;
      const rowIndex = vm.statisticsDetailChartMap['income'].rows.findIndex(row => { return row['日期'] === itemKey });

      if (rowIndex >= 0) {
        vm.statisticsDetailChartMap['income'].rows[rowIndex]['全部目标'] = item.totalTarget;
        vm.statisticsDetailChartMap['income'].rows[rowIndex]['老客目标'] = item.oldTarget;
        vm.statisticsDetailChartMap['income'].rows[rowIndex]['新客目标'] = item.newTarget;
      }
    });
  })
}

const formatRecentProvidersStatisticsDetail = (vm, data, key) => {
  if (vm.dateType === 'hour') {
    data = formatOneDay(data)
  }

  const dataMap = {}
  Object.keys(vm.statisticsDetailChartMap).forEach((chartType) => {
    dataMap[chartType] = JSON.parse(JSON.stringify(vm.statisticsDetailChartMap[chartType].rows))
  })
  data.reverse().forEach((item, dataIndex) => {
    Object.keys(vm.statisticsDetailChartMap).forEach((chartType) => {
      let rowData = ''
      switch (chartType) {
        case 'profit':
          rowData = parseInt(item.profitAmount, 10)
          break;
        case 'income':
          rowData = parseInt(item.paidAmount, 10)
          break;
        case 'follow':
          rowData = item.subscribeCount
          break;
        case 'arpu':
          rowData = (parseInt(item.paidAmount, 10) / (item.subscribeCount || 1)).toFixed(1)
          break;
        case 'arppu':
          rowData = (parseInt(item.paidAmount, 10) / (item.paidCount || 1)).toFixed(1)
          break;
      }
      if (vm.dateType === 'day') {
        const index = dataMap[chartType].findIndex(subItem => {
          return subItem['日期'] === `${item.dateYear}${item.dateMonth}${item.dateDay}`
        })
        dataMap[chartType][index][key] = rowData
      } else {
        dataMap[chartType][dataIndex][key] = rowData
      }
    })
  })

  Object.keys(vm.statisticsDetailChartMap).forEach((chartType) => {
    vm.statisticsDetailChartMap[chartType].rows = dataMap[chartType]
  })
}

const formatDate = (vm, dateType) => {
  if (dateType === 'hour') {
    vm.singleDate = moment().format('YYYY-MM-DD')
  } else if (dateType === 'day') {
    vm.startDate = moment().subtract(29, 'd').format('YYYY-MM-DD')
    vm.endDate = moment().format('YYYY-MM-DD')
  } else if (dateType === 'week') {
    vm.startDate = moment().subtract(7, 'week').startOf('isoWeek').format('YYYY-MM-DD')
    vm.endDate = moment().format('YYYY-MM-DD')
  } else if (dateType === 'month') {
    vm.startDate = moment().subtract(5, 'month').startOf('month').format('YYYY-MM-DD')
    vm.endDate = moment().format('YYYY-MM-DD')
  }
}

const formatStatisticDays = (vm) => {
  vm.statisticDays = []
  const diffDays = moment().diff('2019-01-01', 'd')
  let index = 0
  while (index <= diffDays) {
    vm.statisticDays.push(moment().subtract(index, 'd').format('YYYY-MM-DD'))
    index++
  }
}

const fetchTargetData = (vm) => {
  vm.isLoading = true;
  vm.showTargetTable = false;
  let targetDataMap = {};
  [{ isKA: true }, { isKA: false }].forEach(params => {
    Dushu.getProvidersIncomeTargets(params).then(({ items }) => {
      items.forEach((item) => {
        let key = (item.isKA ? 1 : 0) * 100000000;
        key += item.dateYear * 10000;
        key += (item.dateWeek === '0' ? item.dateMonth : 0) * 100;
        key += item.dateWeek * 10;
        targetDataMap[key] = {
          profitTarget: item.newProfit,
          incomeTarget: item.newTarget,
          followTarget: item.newNewUsers
        };
        targetDataMap[key + 1] = {
          profitTarget: item.oldProfit,
          incomeTarget: item.oldTarget,
          followTarget: item.oldNewUsers
        };
      });

      console.log(targetDataMap)
      vm.targetDataMap = targetDataMap;
      fetchRealData(vm);
    });
  });
}

const fetchRealData = (vm) => {
  vm.isLoading = true;
  vm.showTargetTable = false;
  const { businessTypes, providerTypes, providers, targetSelectType, targetSelectYear, targetValue, targetDataMap } = vm;
  let startDate, endDate;
  const dateTime = moment().year(targetSelectYear)
  if (targetSelectType === 'month') {
    startDate = dateTime.set('month', targetValue - 1).date(1).format('YYYY-MM-DDT00:00:00ZZ');
    endDate = dateTime.set('month', targetValue - 1).endOf('month').format('YYYY-MM-DDT00:00:00ZZ');
  }
  if (targetSelectType === 'week') {
      startDate = dateTime.isoWeek(targetValue).startOf('isoWeek').format('YYYY-MM-DDT00:00:00ZZ');
      endDate = dateTime.isoWeek(targetValue).endOf('isoWeek').format('YYYY-MM-DDT00:00:00ZZ');
  }

  const promiseArray = [];
  [{ isKA: false }, { isKA: true }].forEach(params => {
    [
      { onlineType: '新客户', value: 0 },
      { onlineType: '老客户', value: 1 },
    ].forEach(({ onlineType, value }) => {
      const reqData = {
        businessTypes,
        dataInterval: targetSelectType,
        startDate: startDate,
        endDate: endDate,
        onlineTypes: [onlineType],
        providerTypes,
        providers: providers.map(({ providerId }) => {
          return providerId
        }),
        value,
        ...params,
      };
      promiseArray.push(Dushu.getProvidersStatisticsDetail(reqData));
    });
  });

  Promise.all(promiseArray).then((data) => {
    data.forEach(({ items }, index) => {
      items.forEach((item) => {
        let key = Math.floor(index / 2) * 100000000;
        key += item.dateYear * 10000;
        key += (targetSelectType === 'month' ? item.dateMonth : 0) * 100;
        key += (targetSelectType === 'week' ? item.dateWeek : 0) * 10;
        key += index % 2;
        if (!targetDataMap[key]) {
          targetDataMap[key] = {};
        }
        targetDataMap[key].profitReal = parseInt(item.profitAmount, 10);
        targetDataMap[key].incomeReal = parseInt(item.paidAmount, 10);
        targetDataMap[key].followReal = item.subscribeCount;
      });
    });
    vm.targetDataMap = targetDataMap;
    vm.showTargetTable = true;
    vm.isLoading = false;
  });
}

const getMaxTargetValue = (vm) => {
  const { targetSelectType, targetSelectYear } = vm;
  const dateTime = moment().year(targetSelectYear);
  if (dateTime.isBefore(moment())) return 1000; // 1000虚指最大值

  return targetSelectType === 'week' ? moment().isoWeeks() : dateTime.get('month') + 1;
}

const formatTargetValue = (targetValue, realValue) => {
  return realValue &&  targetValue ? ((realValue / targetValue) * 100).toFixed(1): '-'
}

const isNumber = (value) => {
  return typeof value === 'number' && isFinite(value);
}

export default {
  name: 'dushuAdmin',
  components: {
    VeLine,
    Menu,
    Table,
    FilterModal,
    RankPanel,
  },
  data () {
    return {
      dateType: 'day',
      chartType: 'profit',
      selectedDate: '',
      singleDate: '',
      startDate: '',
      endDate: '',
      onlineType: 'all',
      enablePaymentNotify: false,
      isLoading: false,
      isFilterModalVisible: false,
      dates: [],
      statisticDays: [],
      paginationData: {
        "total": 0,
        "per_page": 100,
        "current_page": 1,
        "last_page": 0,
      },
      menuItems: [{
        id: 1,
        name: '数据汇总',
        active: true,
        icon: chartsPng,
        iconActive: chartsActivePng,
      },{
        id: 3,
        name: '目标对比',
        active: false,
        icon: groupPng,
        iconActive: groupActivePng,
      }, {
        id: 2,
        name: '排行榜',
        active: false,
        icon: detailPng,
        iconActive: detailActivePng,
      // }, {
      //   id: 3,
      //   name: '用户列表',
      //   active: false,
      //   icon: groupPng,
      //   iconActive: groupActivePng,
      }],
      tableStatistics: {
        head: ['日期', '关注', '订单', '付款', '收入', '利润'],
        body: [],
      },
      tableOrders: {
        head: ['日期', '时间', '用户昵称', '金额', '渠道'],
        body: [],
      },
      statisticsDetailChartMap: {
        profit: {
          columns: ['日期', '今日利润'],
          rows: []
        },
        income: {
          columns: ['日期', '今日收入'],
          rows: []
        },
        follow: {
          columns: ['日期', '今日新增关注'],
          rows: []
        },
        arpu: {
          columns: ['日期', '今日arpu'],
          rows: []
        },
        arppu: {
          columns: ['日期', '今日arppu'],
          rows: []
        },
      },
      chartPieData: {
        columns: ['渠道', '用户数'],
        rows: []
      },
      extend: {
        series: {
          smooth: false
        }
      },
      selectMap: {
        vip: {
          all: '所有用户',
          true: '付费用户',
          false: '非付费用户',
        },
        gender: {
          all: '所有性别',
          0: '未知',
          1: '男',
          2: '女',
        }
      },
      userParams: {
        isVip: 'all',
        gender: 'all',
      },
      users: {
        lastDayIncr: '',
        total: '',
        head: ['用户昵称', '性别', '地域', '个号', '关注', '付费'],
        body: [],
      },
      businessTypes: [],
      onlineTypes: [],
      providerTypes: [],
      providers: [],
      filterParams: {
        businessTypes: [],
        onlineTypes: [],
        providerTypes: [],
        providers: [],
      },
      boardDataMap: {
        yesterdayProfit: 0,
        yesterdayAmount: 0,
        totalProfit: 0,
        totalAmount: 0,
        totalPaidUserCount: 0,
        totalSubscribedUserCount: 0,
        subscribedUserCount: 0,
      },
      boardData: [{
        title: '昨日利润',
        key: 'yesterdayProfit',
        class: 'price',
      }, {
        title: '历史总金额',
        key: 'totalAmount',
        class: 'price total',
      }, {
        title: '付费用户数',
        key: 'totalPaidUserCount',
        class: 'user',
      }, {
        title: '当前关注数',
        key: 'subscribedUserCount',
        class: 'user subscribed',
      }],
      chartTypes: [{
        title: '利润',
        key: 'profit',
        className: 'hour-hide',
      }, {
        title: '收入',
        key: 'income',
      }, {
        title: '新增关注',
        key: 'follow',
      }, {
        title: 'ARPU',
        key: 'arpu',
        className: 'hour-hide',
      }, {
        title: 'ARPPU',
        key: 'arppu',
        className: 'hour-hide',
      }],
      dateTypes: [{
        title: '小时',
        key: 'hour',
      }, {
        title: '天',
        key: 'day',
      }, {
        title: '周',
        key: 'week',
      }, {
        title: '月',
        key: 'month',
      }],
      onlineTypeMap: {
        all: '新老客户',
        new: '新客户',
        old: '老客户',
      },
      chartSettings: {},
      showTargetTable: false,
      targetDataMap: {},
      targetYears: [],
      targetSelectYear: moment().year(),
      targetTypes: [{
          value: 'month',
          name: '按月查看'
        }, {
          value: 'week',
          name: '按周查看'
      }],
      targetSelectType: 'month',
      targetValues: Array.from({ length: 12 }, (item, index) => index+1),
      targetValue: '',
      targetTableData: [],
      targetProviderTyps: Utils.PROVIDERTYPES,
      targetUserTypes: Utils.USERTYPES,
      targetValueTypes: [{
        title: '目标利润',
        key: 'profitTarget',
      }, {
        title: '实际利润',
        key: 'profitReal',
      }, {
        title: '利润完成度',
        key: 'profitPercent',
      }, {
        title: '目标收入',
        key: 'incomeTarget',
      }, {
        title: '实际收入',
        key: 'incomeReal',
      }, {
        title: '收入完成度',
        key: 'incomePercent',
      }, {
        title: '目标新增',
        key: 'followTarget',
      }, {
        title: '实际新增',
        key: 'followReal',
      }, {
        title: '新增完成度',
        key: 'followPercent',
      }]
    }
  },
  async mounted () {
    this.isLoading = true
    formatStatisticDays(this)
    const yearDiff = Math.ceil(moment().diff(moment('2020-01-01'), 'years', true));
    this.targetYears = Array.from({ length: yearDiff }, (item, index) => index + 2020);

    this.chartSettings = {
      show: true,
      trigger: 'axis',
      triggerOn: 'click',
      formatter(params) {
        let str = '';
        const pMap = {};
        params.forEach(p => {
          pMap[p.seriesName] = p.data[1] || 0;
          str += `${p.seriesName}: ${p.data[1] || 0} <br/>`
        });

        if ((pMap['全部目标'] || 0) > 0) {
          str += `全部完成度: ${toPercent(pMap['全部收入'], (pMap['全部目标'] || 0))} <br/>`
        }
        if ((pMap['老客目标'] || 0) > 0) {
          str += `老客完成度: ${toPercent(pMap['老客户'], (pMap['老客目标'] || 0))} <br/>`
        }
        if ((pMap['新客目标'] || 0) > 0) {
          str += `新客完成度: ${toPercent(pMap['新客户'], (pMap['新客目标'] || 0))} <br/>`
        }

        return str;
      }
    }

    Dushu.getProviderStatisticsVisibleFilter().then(({ businessTypes, onlineTypes, providerTypes }) => {
      this.businessTypes = [ ...businessTypes ]
      this.onlineTypes = [ ...onlineTypes ]
      this.providerTypes = [ ...providerTypes ]
      this.filterParams.businessTypes = businessTypes
      this.filterParams.onlineTypes = onlineTypes
      this.filterParams.providerTypes = providerTypes
      fetchProviders(this).then(() => {
        fetchProvidersStatistics(this)
        this.onChangeDateType('day')
      })
    })

    const { items } = await Dushu.listShareTypeMetas();
    (items || []).forEach((item) => {
      state.channelMap[item.shareType] = item.name
      state.channels[item.name] = 0
    })

    this.enablePaymentNotify = !!(this.globalData.settings && this.globalData.settings.enablePaymentNotify)
  },
  computed: {
    filterTitle: function () {
      let title = ''
      if (this.businessTypes.length === this.filterParams.businessTypes.length) {
        title += '全部业务'
      } else {
        title += this.filterParams.businessTypes.join('')
      }

      // title += '-'
      // if (this.onlineTypes.length === this.filterParams.onlineTypes.length) {
      //   title += '新老客户'
      // } else {
      //   title += this.filterParams.onlineTypes.join('')
      // }

      title += '-'
      if (this.providerTypes.length === this.filterParams.providerTypes.length) {
        title += '全部类型'
      } else {
        title += `合作方类型(${this.filterParams.providerTypes.length})`
      }

      title += '-'
      if (this.filterParams.providers.length === 1) {
        title += state.providerMap[this.filterParams.providers[0]]
      } else if (this.providers.length === this.filterParams.providers.length) {
        title += '全部读书会'
      } else {
        title += `读书会(${this.filterParams.providers.length})`
      }
      return title
    }
  },
  methods: {
    onFetchProvidersStatistics: function () {
      this.isFilterModalVisible = false
      fetchProvidersStatistics(this)
      fetchProvidersStatisticsDetail(this)
    },
    formatNum: function (num) {
      const numInt = parseInt(num, 10)
      if (numInt < 100000) {
        return numInt
      } else {
        return (numInt / 10000).toFixed(1)
      }
    },
    onChangeFilterParams: function ({ key, value, isMultiUpdate }) {
      if (isMultiUpdate) {
        this.filterParams[key] = value
      } else {
        const optionIndex = this.filterParams[key].indexOf(value)
        if (optionIndex === -1) {
          this.filterParams[key].push(value)
        } else {
          this.filterParams[key].splice(optionIndex, 1)
        }
      }
      if (key !== 'providers') {
        fetchProviders(this, true)
      }
    },
    onChangeMenu: function (activeId) {
      const vm = this;
      // if (activeId === 2) {
      //   this.isLoading = true;
      //   Dushu.exportProviderDailyReport().then(({url}) => {
      //       const myFrame= document.createElement('iframe');
      //       myFrame.src = url;
      //       myFrame.style.display = 'none';
      //       document.body.appendChild(myFrame);
      //       vm.isLoading = false;
      //   });
      //   return;
      // }

      if (activeId === 3 && !vm.menuItems[1].active) {
        vm.targetSelectType = 'month';
        const dateTime = moment().year(vm.targetSelectYear);
        vm.targetValues = Array.from({length: 12}, (item, index) => { return index +1 });
        vm.targetValue = dateTime.get('month') + 1;
        vm.completeness = ((dateTime.date() / dateTime.daysInMonth()) * 100).toFixed(1);
        fetchTargetData(vm)
      }

      this.menuItems = this.menuItems.map((item) => {
        return {
          ...item,
          active: item.id === activeId,
        }
      })
    },
    onChangeTarget: function (key, event) {
      const value = event.target ? event.target.value : event;
      const year = key === 'targetSelectYear' ? value : this.targetSelectYear;
      const dateTime = moment().year(year);
      if (key === 'targetSelectYear' && this.targetSelectType === 'week') {
        const length = dateTime.isoWeeksInYear();
        this.targetValues = Array.from({ length }, (item, index) => index + 1);
      }

      if (key === 'targetSelectType') {
        const length = value === 'week' ? dateTime.isoWeeksInYear() : 12;
        this.targetValues = Array.from({ length }, (item, index) => index + 1);
        if (value === 'week') {
          this.targetValue = dateTime.isoWeeks();
          this.completeness = ((dateTime.isoWeekday() / 7) * 100).toFixed(1);
        } else {
          this.targetValue = dateTime.get('month') + 1;
          this.completeness = ((dateTime.date() / dateTime.daysInMonth()) * 100).toFixed(1)
        }
      }
      if (key === 'targetValue') {
        if (this.targetSelectType === 'week') {
          if (value > dateTime.isoWeeks()) {
            this.completeness = 0
          } else if(value < dateTime.isoWeeks()) {
            this.completeness = 100
          } else {
            this.completeness = ((dateTime.isoWeekday() / 7) * 100).toFixed(1);
          }
        } else {
          if (value > dateTime.get('month') + 1) {
            this.completeness = 0
          } else if(value < dateTime.get('month') + 1) {
            this.completeness = 100
          } else {
            this.completeness = ((dateTime.date() / dateTime.daysInMonth()) * 100).toFixed(1)
          }
        }
      }

      this[key] = value;
      fetchRealData(this);
    },
    onChangeDateType: function (dateType) {
      this.dateType = dateType
      formatDate(this, dateType)
      fetchProvidersStatisticsDetail(this)

      const invalidChartType = ['profit', 'arpu', 'arppu']
      if (dateType === 'hour' && invalidChartType.includes(this.chartType)) {
        this.chartType = 'income'
      }
    },
    onChangeChartType: function (chartType) {
      this.chartType = chartType
    },
    onChangeDate: function (event) {
      const date = event.target.value
      this.selectedDate = {
        label: date ? date.substring(0, 10) : '全部',
        value: date,
      }
      state.channels = {}
      Object.keys(state.channelMap).forEach((item) => {
        state.channels[state.channelMap[item]] = 0
      })
      formatOrders(this)
    },
    onChangeUserParamsVip: function (event) {
      const value = event.target.value
      this.userParams.isVip = value

      // this.$toast('loading...')
      this.paginationData['current_page'] = 1
      fetchUsers(this)
    },
    onChangeUserParamsGender: function (event) {
      const value = event.target.value
      this.userParams.gender = value

      // this.$toast('loading...')
      this.paginationData['current_page'] = 1
      fetchUsers(this)
    },
    onChangePaymentNotify: function () {
      this.enablePaymentNotify = !this.enablePaymentNotify
      Dushu.partnerUpdateSetting(this.enablePaymentNotify)
    },
    onPageChange: function (page) {
      this.paginationData['current_page'] = page
      // this.users.body = state.users[page]
      fetchUsers(this)
    },
    onChangeDay: function (key, event) {
      const value = event.target.value
      this[key] = value

      fetchProvidersStatisticsDetail(this)
    },
    onExportData: function () {
      const vm = this;
      this.isLoading = true;
      Dushu.exportProviderDailyReport().then(({ url }) => {
        if (url) {
          if (utils.isAndroid()) {
            const myFrame= document.createElement('iframe');
            myFrame.src = url;
            myFrame.style.display = 'none';
            document.body.appendChild(myFrame);
            vm.isLoading = false;
          } else {
            window.location.href = url;
          }
        }
      });
    },
    getMaxTargetValue: function() {
      const { targetSelectType, targetSelectYear } = this;
      const dateTime = moment().year(targetSelectYear);
      if (dateTime.isBefore(moment())) return 1000; // 1000虚指最大值

      return targetSelectType === 'week' ? moment().isoWeeks() : dateTime.get('month') + 1;
    },
    getCompleteness: function () {
      const { targetSelectYear, completeness } = this;
      const dateTime = moment().year(targetSelectYear);
      if (dateTime.isBefore(moment())) return 100; // 指完成度100%

      return completeness;
    },
    getTargetProviderTypes: function () {
      return Utils.getTargetProviderTypes(this.targetSelectTableType);
    },
    getTargetValue: function (isKA, isOld, targetKey) {
      const { targetSelectType, targetSelectYear, targetValue, targetDataMap } = this;
      let key = (isKA ? 1 : 0) * 100000000;
      key += targetSelectYear * 10000;
      key += (targetSelectType === 'month' ? targetValue : 0) * 100;
      key += (targetSelectType === 'week' ? targetValue : 0) * 10;
      key += isOld ? 1 : 0;

      if (targetKey.indexOf('Percent') === -1) {
        return (targetDataMap[key] || {})[targetKey] || 0;
      }
      const targetVal = (targetDataMap[key] || {})[targetKey.replace('Percent', 'Target')] || 0;
      const realVal = (targetDataMap[key] || {})[targetKey.replace('Percent', 'Real')] || 0;
      return (realVal && targetVal && targetVal !== '0') ? `${(realVal * 100 / targetVal).toFixed(1)}%` : '-';
    },
    showFilterModal: function () {
      this.isFilterModalVisible = true
    }
  },
};
</script>

<style src="./index.scss" lang="scss"></style>
